export default{alert:"w_AN",content:"w_AO",leading:"w_AP",error:"w_AQ",info:"w_AR",success:"w_AS",warning:"w_AT"};
